export default [
  {
    value: null,
    text: 'None'
  },
  {
    value: 'Breege',
    text: 'Breege'
  },
  {
    value: 'Megan',
    text: 'Megan'
  },
  {
    value: 'MaryClaire',
    text: 'MaryClaire'
  },
  {
    value: 'Mike',
    text: 'Mike'
  },
  {
    value: 'Patrick',
    text: 'Patrick'
  },
  {
    value: 'Loui',
    text: 'Loui'
  },
  {
    value: 'Tomas',
    text: 'Tomas'
  },
  {
    value: 'Sean',
    text: 'Sean'
  },
  {
    value: 'Sean Byrne',
    text: 'Sean Byrne'
  },
  {
    value: 'Stephen',
    text: 'Stephen'
  }
];
